import React from 'react';
import HeaderBox from 'components/HeaderBox';
import Loading from 'components/Loading';
import MessageBox from 'components/MessageBox';
import { Wrapper, Content, Line, MLabel, SHeader } from './styles';
import { useSiteDetails } from './useSiteDetails';
import dayjs from 'dayjs';
import SalesGoodsItem from './SalesGoodsItem';
import {COMMON} from 'constants';
import BackButton from 'components/BackButton';

const SiteDetails = () => {
    const { siteDetails, isLoading, message, setMessage } = useSiteDetails();
    const totalPrice = siteDetails.SalesGoods?.reduce((total, item) => {
        return total + Number(item?.TotalPrice || 0);
    }, 0);
    return (
      <>
        {siteDetails?.SiteID > 0 && ( 
        <Wrapper>
            <Loading isLoading={isLoading} />
            <HeaderBox title={'現場明細'} showCart />
            <MessageBox message={message} setMessage={setMessage} />
            <Content>
                <Line>
                    <MLabel>現場：</MLabel>
                    {siteDetails.SiteName || '―'}
                </Line>
                <Line>
                    <MLabel>住所：</MLabel>
                    <a href={`https://www.google.co.jp/maps/place/${siteDetails.AddressPrefecture || ''}${siteDetails.AddressCity || ''}${siteDetails.AddressNumber || ''}`}
                        target="_blank" rel="noopener noreferrer">
                        〒{siteDetails.PostalCode || '―'}　{siteDetails.AddressPrefecture || ''}{siteDetails.AddressCity || ''}{siteDetails.AddressNumber || ''}
                    </a>
                </Line>
                <Line>
                    <MLabel>TEL：</MLabel>
                    {siteDetails.Tel || '―'}
                </Line>
                <Line>
                    <span ><MLabel>期間：</MLabel>{siteDetails.DateBeginning.length > 9 ? dayjs(siteDetails.DateBeginning).format("YYYY年MM月DD日") : '－'}</span>～
                    <span>{siteDetails.DateFinished.length > 9 ? dayjs(siteDetails.DateFinished).format("YYYY年MM月DD日") : '－'}</span>
                </Line>
                <Line>
                    <MLabel>面積：</MLabel>{siteDetails.Area || '―'}m<sup>2</sup>
                </Line>
                <Line>
                    <MLabel>メモ：</MLabel>{siteDetails.SiteClientMemo || '―'}
                </Line>
                {!!siteDetails.PriceVisible && (<><Line>
                    <MLabel>合計金額：</MLabel>{COMMON.NumFormat(totalPrice) || '―'}
                </Line>
                </>)}
                {/*  */}
                <SHeader>商品一覧</SHeader>
                {siteDetails.SalesGoods?.length > 0 && (<>
                    {siteDetails.SalesGoods.map((item) => {
                        return <SalesGoodsItem key={item.SalesGoodsID} priceVisible={!!siteDetails.PriceVisible} item={item} />
                    })}
                </>)}
            </Content>
            <BackButton />
        </Wrapper>)}
      </>
    )
}

export default SiteDetails;